import { render, staticRenderFns } from "./certificaciones.vue?vue&type=template&id=7f7e5076&scoped=true"
import script from "./certificaciones.vue?vue&type=script&lang=js"
export * from "./certificaciones.vue?vue&type=script&lang=js"
import style0 from "./certificaciones.vue?vue&type=style&index=0&id=7f7e5076&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f7e5076",
  null
  
)

export default component.exports